import {SurveysResponsesState} from './responses.interface';

export const responsesInitialState: SurveysResponsesState = {
    ids: [],
    entities: {},
    responses: [],
    complete: false
};
